import React from 'react'

export default function TNFIcon() {
  return (
    <>
        <svg width="40" height="40" viewBox="0 0 45 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.28814 0C2.89499 0 3.47698 0.235215 3.90609 0.653901C4.3352 1.07259 4.57627 1.64045 4.57627 2.23256V7.73953L9.82373 6.71554C14.8601 5.73633 20.0795 6.20371 24.8492 8.06102L25.4715 8.30214C30.2336 10.1611 35.4749 10.509 40.4512 9.29637C40.9909 9.16475 41.5542 9.15485 42.0984 9.26745C42.6426 9.38004 43.1534 9.61216 43.5919 9.94617C44.0303 10.2802 44.3851 10.7073 44.6291 11.1951C44.8731 11.6829 44.9999 12.2185 45 12.7613V34.691C45 36.608 43.6607 38.2809 41.7539 38.7453L41.101 38.9031C35.7026 40.2198 30.0162 39.8438 24.8492 37.8285C20.0805 35.9717 14.8622 35.5044 9.82678 36.483L4.57627 37.507V61.7674C4.57627 62.3596 4.3352 62.9274 3.90609 63.3461C3.47698 63.7648 2.89499 64 2.28814 64C1.68128 64 1.09929 63.7648 0.670179 63.3461C0.24107 62.9274 0 62.3596 0 61.7674V2.23256C0 1.64045 0.24107 1.07259 0.670179 0.653901C1.09929 0.235215 1.68128 0 2.28814 0Z" fill="#11C900"/>
</svg>

    </>
  )
}
